export default "__VITE_ASSET__066eeb9a__"